import Helmet from 'react-helmet';

import Routes from './Routes';

import './components/auth.scss';

export default function AuthLayout() {
  return <>
    <Helmet
      title="Authentication"
      titleTemplate="%s | Path Evolution"
      meta={[
        { 'char-set': 'utf-8' },
        { name: 'description', content: 'Path Evolutionn' },
      ]} />
    <Routes />
  </ >
}
